import { render } from "./CapitalDetail.vue?vue&type=template&id=dd22fe92&scoped=true"
import script from "./CapitalDetail.vue?vue&type=script&lang=js"
export * from "./CapitalDetail.vue?vue&type=script&lang=js"

import "./CapitalDetail.vue?vue&type=style&index=0&id=dd22fe92&lang=less&scoped=true"

import exportComponent from "D:\\新建文件夹 (2)\\前端\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd22fe92"]])

export default __exports__